





































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import TicketHelper from '@/mixins/TicketHelper.vue';

import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';

@Component({
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive,
    },
    data() {
        return {
            swiperOption: {
                direction: 'horizontal',
                slidesPerView: 'auto',
                freeMode: false,
                mousewheel: true,
            },
        };
    },
})
export default class StaffTicketsHeader extends Mixins(TicketHelper) {
    public tabKey: string = 'my';
    public ticketsSearchQuery: string = '';
    public activeSlide: number = -1;
    private keyboardListenerAdded: boolean = false;

    constructor() {
        super();

        this.initializeKeyboardListener();
    }

    public initializeKeyboardListener(): void {
        if (this.keyboardListenerAdded === true) {
            return;
        }

        if (this.$store.state.Viewport.deviceInfo.platform === 'web') {
            this.keyboardListenerAdded = true;
            return;
        }

        Keyboard.addListener('keyboardDidShow', (info: KeyboardInfo) => {
            this.$store.commit(Mutations.SET_INDEX_PAGES_KEYBOARD_VISIBILITY, true);
        });

        Keyboard.addListener('keyboardDidHide', () => {
            this.$store.commit(Mutations.SET_INDEX_PAGES_KEYBOARD_VISIBILITY, false);
        });

        this.keyboardListenerAdded = true;
    }

    public tabClickHandler(type: string) {
        this.$store.commit(Mutations.SET_ACTIVE_STAFF_TICKETS_TYPE, type);
        this.$store.dispatch(Actions.FETCH_ALL_USER_TICKETS, { vue: this, type });
        this.tabKey = type;
    }

    public isActiveClass(elementTabKey: string) {
        return {
            'hococo-active-tab': (this.tabKey === elementTabKey),
            'hococo-inactive-tab': (this.tabKey !== elementTabKey),
        };
    }

    public setTicketsSearchQuery() {
        this.$store.commit(Mutations.SET_TICKET_SEARCH_QUERY, this.ticketsSearchQuery);
    }

    public changeTicketStatusFilter(slide: number) {
        const statuses = document.querySelectorAll('.ticket-status-links');

        statuses.forEach((status) => status.classList.remove('ticket-status-active'));
        statuses[slide].classList.toggle('ticket-status-active');

        const swiper: any = this.$refs.statusesSwiper;

        swiper.$swiper.slideTo(slide, 1000, false);
        this.activeSlide = --slide;
        this.$store.commit(Mutations.SET_TICKET_SELECTED_PRIORITY, this.activeSlide);
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffLanguageButton);
    }
}
